<template>
    <transition name="fade">
        <div v-show="modelValue" class="fixed inset-0 z-20 overflow-hidden">
            <!-- Backdrop -->
            <div class="absolute inset-0 -z-1 bg-gray-900 bg-opacity-80"></div>

            <!-- Cancel Button -->
            <div
                class="
                    absolute
                    top-0
                    right-0
                    text-4xl
                    p-4
                    text-white
                    cursor-pointer
                    z-10
                "
                @click="cancel"
            >
                <span class="icon-np-cancel"></span>
            </div>

            <!-- Modal -->
            <div
                class="
                    absolute
                    inset-y-0
                    w-full
                    flex
                    justify-center
                    items-center
                "
            >
                <div
                    class="
                        relative
                        overflow-hidden
                        bg-white
                        py-6
                        px-6
                        rounded-2xl
                    "
                >
                    <!-- Content -->
                    <slot />
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.fade-leave-active,
.fade-enter-active {
    transition: 0.8ms;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        modelValue(newValue) {
            if (newValue) {
                document.addEventListener("keyup", this.handleKeyup);
            } else {
                document.removeEventListener("keyup", this.handleKeyup);
            }
        },
    },
    methods: {
        handleKeyup(event) {
            if (event.keyCode === 27) {
                // escape key
                this.cancel();
            }
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>
